import { useQuery } from '@tanstack/react-query';

import { billingClient } from 'api/billing';
import type { BillingProfileResponse } from 'api/types';
import { QueryKeys } from 'entities/billing/api/common';
import { useAuth } from 'shared/lib/auth/useAuth';

const isTemporaryState = (data: BillingProfileResponse | undefined) => {
  if (!data) {
    return false;
  }

  return data.subscription_status === 'in_progress' || data.payment_status === 'processing';
};

export const useGetBillingProfile = () => {
  const { permissions } = useAuth();

  const enabled = permissions.has('can_edit_billing') || permissions.has('can_view_billing');

  const query = useQuery({
    queryKey: [QueryKeys.getBillingProfile],
    queryFn: () => billingClient.getBillingProfile(),
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    enabled,
    staleTime: 1000 * 30,
    refetchIntervalInBackground: true,
    refetchInterval: (query) => {
      return isTemporaryState(query.state.data) ? 5000 : false;
    },
  });

  return {
    ...query,
    isPolling: isTemporaryState(query.data) && !query.isError,
  };
};
